import  './../css/Gtop.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Properties,systemConfiguration,Endpoint, fetchOperation ,getHeaders,handleEncode,getDecryptedValueByProperty} from '../../../src/CommonImports';
import {useEffect,useState } from '../../InBuildImports';

function GBrowseByCategory(){
  const token = getDecryptedValueByProperty(Properties.SESSION_TOKEN_PROP);
  const userId = getDecryptedValueByProperty(Properties.USER_ID_PROP);
  const Header_Json = getHeaders(token, handleEncode(userId));
  const [jobsData, setJobsData] = useState([]);
useEffect(() => {
 fetchData();
}, []);

 const fetchData = async () => {

    const jobTitles = ["Marketing","Data Architect","Senior QA","DevOps Engineer","System Analyst","Senior Analyst","Programmer"];
    // setLoading(true)
     const url = systemConfiguration.HOST + Endpoint.BROWSE_BY_CATEGORY+"?jobTitle="+jobTitles.join(",");
          fetchOperation(url,Header_Json)
          .then(res=>{
            setJobsData(res)
          console.log(""+res[0].companyName);
            // setLoading(false);
      })
      .catch(()=>{
        // setError('Failed to fetch the data');
        // setLoading(false)
  })
  };

const cardImages = [
  "marketing&com.svg",       
  "content-writer.svg",      
  "marketing-director.svg",  
  "system-analyst.svg",      
  "digital-designer.svg",    
  "marketing&resarch.svg",   
  "human-resource.svg",      
  "programmer.svg"           
];
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    
return (
<section className="section-box">
  <div className="container browse-custom">
    <div className="row align-items-end mb-5">
      
      <div className="col-lg-7">
        <h2 className="fw-bold">Browse by category</h2>
        <p className="text-muted">Find the type of work you need, clearly defined and ready to start. Work begins as soon as you purchase and provide requirements.</p>
      </div>
      <div className="col-lg-5 text-lg-end text-start">
        <a href="/job-grid-2.html" className="btn btn-outline-primary mt-3 mt-lg-0">
          Browse all
        </a>
      </div>
    </div>

         <div className="row justify-content-center g-4">

          {jobsData?.map((item, index) => (

            <div
              className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center"
              key={index}
            >

              <div className="card custom-card shadow-sm border-1 rounded-3 hover-up d-flex flex-column">

                <img
                  src={`${mediaUrl}${cardImages[index % cardImages.length]}?${sasToken}`}
                  alt={item.jobTitle}
                  className="img-fluid mx-auto mt-3"
                />

                <div className="card-body text-center d-flex flex-column">

                  <h5 className="mb-2">
                    <a
                      href="/job-grid.html"
                      className="text-decoration-none text-dark"
                    >
                      {item.jobTitle}
                    </a>
                  </h5>

                  <p className="text-muted mb-2">
                    {item.noOfVacancy} Available Vacancy
                  </p>

                  <div className="mt-auto">
                    <a
                      href="/job-grid.html"
                      className="btn btn-primary btn-sm"
                    >
                      View Jobs
                    </a>
                  </div>

                </div>

              </div>

            </div>

          ))}
          <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
            <div className="card custom-card shadow-sm border-1 rounded-3 hover-up d-flex flex-column">
              {/* <img src={mediaUrl+"human-resource.svg?"+sasToken} alt="Jobs Icon" className="img-fluid mx-auto mt-3" style={{ width: "55px",height: "55px",objectFit: "contain"}}/> */}
              <div className="card-body text-center d-flex flex-column">
                <h3 className="fw-bold mb-2">18,265+</h3>
                <p className="fw-bold text-muted mb-3">Jobs are waiting for you</p>
                <div className="mt-auto">
                  <a href="#" className="btn btn-primary btn-sm">Explore More</a>
                </div>
              </div>
            </div>
          </div>

    </div>
   
 </div>
</section>

);
}
export default GBrowseByCategory;